module.exports = __webpack_public_path__ + "img/16-6.9ce4a472.png";